import React, { useEffect, useState } from 'react';
import { fetchWithAuth } from '../services/api';
import { Navigate, useLocation } from 'react-router-dom';
import {
  getLanguageFromPath,
  hasValidAuthentication,
  saveIntendedDestination,
} from '../services/auth';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = hasValidAuthentication();
  const location = useLocation();
  const [eligibility, setEligibility] = useState(null);
  const isAccountPage = location.pathname.endsWith('/my-profile');
  useEffect(() => {
    let active = true;
    setEligibility(null);
    if (isAuthenticated && !isAccountPage) {
      fetchWithAuth('/users/me').then(user => {
        if (active) setEligibility(user.ageConfirmationRequired ? 'required' : 'eligible');
      }).catch(() => { if (active) setEligibility('error'); });
    }
    return () => { active = false; };
  }, [isAuthenticated, isAccountPage, location.pathname]);

  if (!isAuthenticated) {
    // Store the current location to redirect back after login
    saveIntendedDestination(location.pathname + location.search + location.hash);
    // Redirect to the login page, maintaining the language prefix
    const lang = getLanguageFromPath(location.pathname);
    return <Navigate to={`/${lang}/login`} replace />;
  }

  if (!isAccountPage) {
    if (eligibility === null) return <div role="status" aria-busy="true" />;
    if (eligibility === 'required' || eligibility === 'error') {
      return <Navigate to={`/${getLanguageFromPath(location.pathname)}/my-profile`} replace />;
    }
  }
  return children;
};

export default ProtectedRoute;
